// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2yRVB","content":"LoadingAlert_content__1cBuf"};